var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShouhuoguanli = function SvgShouhuoguanli(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "shouhuoguanli_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65E0C7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AC7A4",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#shouhuoguanli_svg__a)",
    width: 32,
    height: 32,
    rx: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.918 19.923a1.962 1.962 0 1 1 0 3.923 1.962 1.962 0 0 1 0-3.923Zm7.846 0a1.962 1.962 0 1 1 0 3.923 1.962 1.962 0 0 1 0-3.923Zm3.428-11.115c.677 0 1.234.514 1.301 1.174l.007.133v11.116c0 .328-.242.6-.557.647l-.097.007h-.812a3.27 3.27 0 0 0-6.534-.186l-.005.186h-1.308a3.27 3.27 0 0 0-6.533-.186l-.005.186h-.495a.654.654 0 0 1-.647-.558l-.007-.096v-5.397c0-.461.243-.885.633-1.12l.121-.064 2.666-1.246a.327.327 0 0 0 .18-.222l.008-.074v-2.993c0-.677.515-1.234 1.174-1.3l.134-.007h10.776Zm-7.846 3.269h-.654a.327.327 0 0 0-.327.327v2.288h-2.288a.327.327 0 0 0-.327.327v.654c0 .18.146.327.327.327h3.27l.065-.007a.327.327 0 0 0 .261-.32v-3.27a.327.327 0 0 0-.327-.326Z",
    fill: "#FFF"
  }))));
};

export default SvgShouhuoguanli;